import { render, staticRenderFns } from "./NotEligible.vue?vue&type=template&id=4c87f0bd&scoped=true&"
import script from "./NotEligible.vue?vue&type=script&lang=js&"
export * from "./NotEligible.vue?vue&type=script&lang=js&"
import style0 from "./NotEligible.vue?vue&type=style&index=0&id=4c87f0bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c87f0bd",
  null
  
)

export default component.exports